import { Store } from "@tanstack/react-store";

export type Theme =
	| "theme-gray"
	| "theme-green"
	| "theme-blue"
	| "theme-purple"
	| "theme-pink"
	| "theme-red"
	| "theme-orange"
	| "theme-yellow";

export const themeMap: Record<Theme, number> = {
	"theme-gray": 0,
	"theme-green": 1,
	"theme-blue": 2,
	"theme-purple": 3,
	"theme-pink": 4,
	"theme-red": 5,
	"theme-orange": 6,
	"theme-yellow": 7,
};

interface ThemeState {
	theme: Theme;
	background: number | null;
}

const getStoredTheme = (): Theme => {
	if (typeof window === "undefined") return "theme-gray";
	return (localStorage.getItem("app-theme") as Theme) || "theme-gray";
};

const getStoredBackground = (): number | null => {
	if (typeof window === "undefined") return null;
	const bg = localStorage.getItem("app-background");
	return bg !== null ? parseInt(bg, 10) : null;
};

export const themeStore = new Store<ThemeState>({
	theme: getStoredTheme(),
	background: getStoredBackground(),
});

export const setTheme = (theme: Theme) => {
	localStorage.setItem("app-theme", theme);
	document.documentElement.setAttribute("data-theme", theme);
	themeStore.setState((state) => ({ ...state, theme }));
};

export const setBackground = (background: number) => {
	localStorage.setItem("app-background", background.toString());
	themeStore.setState((state) => ({ ...state, background }));
};

// Initialize theme on load
if (typeof window !== "undefined") {
	document.documentElement.setAttribute("data-theme", getStoredTheme());
}
